import { Dispatch, SetStateAction, useState } from "react";
import { PharmaStpFileModel } from "../../../data-model/nycbsPharmaOrder";
import { NycbsExternalTableState } from "../types/nycbsExternalTableState";

export type { NycbsExternalTableState } from "../types/nycbsExternalTableState";

export interface UseNycbsExternalTableDataReturn {
  nycbsExternalState: NycbsExternalTableState;
  setNycbsExternalState: Dispatch<SetStateAction<NycbsExternalTableState>>;
  tableData: PharmaStpFileModel[];
  setTableData: Dispatch<SetStateAction<PharmaStpFileModel[]>>;
}

/**
 * Holds table row data and NYCBS External fetch state for the orders table.
 *
 * @returns Table rows plus loading/error state for the NYCBS External worklist
 */
export const useNycbsExternalTableData = (): UseNycbsExternalTableDataReturn => {
  const [tableData, setTableData] = useState<PharmaStpFileModel[]>([]);
  const [nycbsExternalState, setNycbsExternalState] =
    useState<NycbsExternalTableState>({
      data: undefined,
      loading: false,
      error: null,
      showInlineLoader: false,
    });

  return {
    nycbsExternalState,
    setNycbsExternalState,
    tableData,
    setTableData,
  };
};
